module.exports = __webpack_public_path__ + "img/A001.62c63fa7.png";